import { Component, Input, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { Observable } from 'rxjs';
import { resumeDataInterface } from '../../interfaces/resume';

@Component({
  selector: 'mcrit-gestio-list-resume',
  templateUrl: './list.resume.component.html',
  styleUrls: ['./list.resume.component.css']
})
export class ListResumeComponent implements OnInit {
  @Input() dades: resumeDataInterface;
  @Input() titol: string;

  constructor(public translate: TranslateService, public languageService: LanguageService, ){}

  ngOnInit(){}

}
